export default __webpack_public_path__ + "static/media/Greenhouse_02.bf185675.webp";